// extracted by mini-css-extract-plugin
export default {"SpaceListWrapper":"SpaceList_SpaceListWrapper__duL2a","SpaceListItem":"SpaceList_SpaceListItem__MWPZ9","SpaceListItemMeta":"SpaceList_SpaceListItemMeta__RF0g+"};